import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { PlusIcon, SearchIcon, MoreVerticalIcon } from 'lucide-react';
interface Supplier {
  id: string;
  companyName: string;
  contactPerson: string;
  email: string;
  phone: string;
  productsSupplied: string;
  status: 'Active' | 'Inactive';
  totalOrders: number;
  lastOrderDate: string;
}
export function Suppliers() {
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState('');
  // Mock data
  const suppliers: Supplier[] = [{
    id: '1',
    companyName: 'Premium Tea Estates Ltd',
    contactPerson: 'Rajesh Kumar',
    email: 'rajesh@premiumtea.lk',
    phone: '+60 12 345 6789',
    productsSupplied: 'Ceylon Black Tea, Green Tea',
    status: 'Active',
    totalOrders: 45,
    lastOrderDate: '2024-01-15'
  }, {
    id: '2',
    companyName: 'Spice Traders Co',
    contactPerson: 'Amara Silva',
    email: 'amara@spicetraders.lk',
    phone: '+60 13 234 5678',
    productsSupplied: 'Cinnamon, Cardamom, Cloves',
    status: 'Active',
    totalOrders: 32,
    lastOrderDate: '2024-01-18'
  }, {
    id: '3',
    companyName: 'Packaging Solutions',
    contactPerson: 'John Fernando',
    email: 'john@packagingsolutions.lk',
    phone: '+60 10 345 6789',
    productsSupplied: 'Tea Boxes, Labels, Bags',
    status: 'Active',
    totalOrders: 28,
    lastOrderDate: '2024-01-12'
  }, {
    id: '4',
    companyName: 'Organic Herbs Ltd',
    contactPerson: 'Nisha Perera',
    email: 'nisha@organicherbs.lk',
    phone: '+60 12 456 7890',
    productsSupplied: 'Herbal Tea Ingredients',
    status: 'Inactive',
    totalOrders: 15,
    lastOrderDate: '2023-12-20'
  }];
  const filteredSuppliers = suppliers.filter(supplier => supplier.companyName.toLowerCase().includes(searchQuery.toLowerCase()) || supplier.contactPerson.toLowerCase().includes(searchQuery.toLowerCase()) || supplier.email.toLowerCase().includes(searchQuery.toLowerCase()));
  return <div className="space-y-6" data-id="element-9153">
      {/* Header */}
      <div className="flex justify-between items-center" data-id="element-9154">
        <div data-id="element-9155">
          <h2 className="text-2xl font-semibold text-gray-900" data-id="element-9156">Suppliers</h2>
          <p className="text-sm text-gray-500 mt-1" data-id="element-9157">
            Manage your supplier relationships
          </p>
        </div>
        <button onClick={() => navigate('/supplier-form')} className="flex items-center px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700" data-id="element-9158">
          <PlusIcon size={18} className="mr-2" data-id="element-9159" />
          Add Supplier
        </button>
      </div>
      {/* Search and Filter */}
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-4" data-id="element-9160">
        <div className="flex items-center space-x-4" data-id="element-9161">
          <div className="flex-1 relative" data-id="element-9162">
            <SearchIcon size={18} className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" data-id="element-9163" />
            <input type="text" placeholder="Search suppliers..." value={searchQuery} onChange={e => setSearchQuery(e.target.value)} className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" data-id="element-9164" />
          </div>
        </div>
      </div>
      {/* Suppliers Table */}
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden" data-id="element-9165">
        <div className="overflow-x-auto" data-id="element-9166">
          <table className="w-full" data-id="element-9167">
            <thead className="bg-gray-50 border-b border-gray-200" data-id="element-9168">
              <tr data-id="element-9169">
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-9170">
                  Company
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-9171">
                  Contact Person
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-9172">
                  Products Supplied
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-9173">
                  Total Orders
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-9174">
                  Status
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-9175">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200" data-id="element-9176">
              {filteredSuppliers.map(supplier => <tr key={supplier.id} className="hover:bg-gray-50 cursor-pointer" onClick={() => navigate(`/supplier-detail/${supplier.id}`)} data-id="element-9177">
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-9178">
                    <div className="text-sm font-medium text-gray-900" data-id="element-9179">
                      {supplier.companyName}
                    </div>
                    <div className="text-sm text-gray-500" data-id="element-9180">
                      {supplier.email}
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-9181">
                    <div className="text-sm text-gray-900" data-id="element-9182">
                      {supplier.contactPerson}
                    </div>
                    <div className="text-sm text-gray-500" data-id="element-9183">
                      {supplier.phone}
                    </div>
                  </td>
                  <td className="px-6 py-4" data-id="element-9184">
                    <div className="text-sm text-gray-900" data-id="element-9185">
                      {supplier.productsSupplied}
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-9186">
                    <div className="text-sm text-gray-900" data-id="element-9187">
                      {supplier.totalOrders}
                    </div>
                    <div className="text-xs text-gray-500" data-id="element-9188">
                      Last: {supplier.lastOrderDate}
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-9189">
                    <span className={`px-2 py-1 inline-flex text-xs leading-5 font-semibold rounded-full ${supplier.status === 'Active' ? 'bg-green-100 text-green-800' : 'bg-gray-100 text-gray-800'}`} data-id="element-9190">
                      {supplier.status}
                    </span>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium" data-id="element-9191">
                    <button onClick={e => {
                  e.stopPropagation();
                }} className="text-gray-400 hover:text-gray-600" data-id="element-9192">
                      <MoreVerticalIcon size={18} data-id="element-9193" />
                    </button>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </div>
    </div>;
}